import { render, staticRenderFns } from "./delete-document.vue?vue&type=template&id=3613dd7e&scoped=true&"
import script from "./delete-document.vue?vue&type=script&lang=js&"
export * from "./delete-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613dd7e",
  null
  
)

export default component.exports